import * as Yup from 'yup';

export const FolderBusinessEntityCodingConfigSchema = Yup.object().shape({
  codingConfig: Yup.object().shape({
    code: Yup.string().required('Le code est requis'),
  }),
});
